<template>
  <div class="wrapper">
    <div class="__container" v-if="!showTerms">
      <div class="form" v-if="!is_registering">
        <div class="logo">
          <img src="@/assets/images/logo/new_logo.svg" />
        </div>
        <div class="banner">
          <h1>Welcome</h1>
          <span>A few steps to get started…</span>
        </div>
        <div class="login_form">
          <div class="chech-box">
            <input type="radio" id="consultant" name="account_type" value="4" v-model="signup_fields.account_type" />
            <label for="consultant">I am a consultant</label>
          </div>
          <div class="chech-box">
            <input type="radio" id="customer" name="account_type" value="2" v-model="signup_fields.account_type" />
            <label for="customer">I am a company with assignments</label>
          </div>
          <div class="chech-box">
            <input type="radio" id="supplier" name="account_type" value="3" v-model="signup_fields.account_type" />
            <label for="supplier">I am a company with consultants</label>
          </div>
          <button class="get-started" @click="is_registering = true">
            Get Started
          </button>
        </div>
      </div>
      <div class="form" v-if="is_registering">
        <div class="logo">
          <img src="@/assets/images/logo/new_logo.svg" />
        </div>
        <div class="banner">
          <h5>Welcome to Consultified!</h5>
          <h1>Create your account</h1>
        </div>
        <div class="login_form">
          <label class="label">First name</label>
          <widgetInput type="text" v-model="signup_fields.first_name" placeholder="Type your first name"
            v-validate="'required'"></widgetInput>

          <div class="error-msg" v-show="isErrorOnFirstName">
            {{ getErrorMsg.message | validate }}
          </div>

          <label class="label">Last name</label>
          <widgetInput type="text" v-model="signup_fields.last_name" placeholder="Type your last name"
            v-validate="'required'"></widgetInput>

          <div class="error-msg" v-show="isErrorOnLastName">
            {{ getErrorMsg.message | validate }}
          </div>
          <label class="label">E-mail</label>
          <widgetInput type="email" v-model="signup_fields.email" placeholder="Type your E-mail" v-validate="'required'">
          </widgetInput>

          <div class="error-msg" v-show="isErrorOnEmail">
            {{ getErrorMsg.message | validate }}
          </div>
          <label class="label">Password</label>
          <VuePassword type="password" placeholder="Type your Password" class="password-input" v-validate="'required'"
            v-model="signup_fields.password" :strength="pass_strength" :class="{ error_input: isErrorOnPassword }" />
          <div class="error-msg" v-show="isErrorOnPassword">
            {{ getErrorMsg.message | validate }}
          </div>
          <div class="error-msg" v-show="weekPassword && signup_fields.password">
            Your password is not strong
          </div>

          <label class="label">Confirm Password</label>
          <VuePassword type="password" placeholder="Re-type your Password" class="password-input" v-validate="'required'"
            v-model="signup_fields.comfirm_password" @keyup.enter="signUpByConsultified()" :disableStrength="false"
            :class="{ error_input: isErrorOnComfirmPassword }" />

          <div class="error-msg" v-show="isErrorOnComfirmPassword">
            {{ getErrorMsg.message | validate }}
          </div>
          <div class="error-msg" v-if="error_message">
            {{ error_message | validate }}
          </div>
        </div>
        <div class="bottom">
          <div class="chech-box">
            <input type="checkbox" id="check" v-model="check" />
            <label for="check" style="margin-right: 3px">Accept</label>
            <label class="colored" @click="showTerms = !showTerms">Terms & Conditions</label>
          </div>

          <widgetButton :loading="loading" @click="signUpByConsultified()" class="btn-signup btn-secondary">
            Sign Up
          </widgetButton>
          <div class="loader" v-show="loading">
            <img src="@/assets/icons/loading_blue.gif" alt />
          </div>
          <label class="sign-in-up-option">Sign Up with</label>

          <ul class="social-media-list">
            <li class="linkedin">
              <a @click.prevent="signUpBySocial('linkedin')">
                <img src="@/assets/icons/linkedin.svg" alt />
                <span>Linked In</span>
              </a>
            </li>
            <li class="divider"></li>
            <li class="google">
              <a @click.prevent="signUpBySocial('google')">
                <img src="@/assets/icons/google.svg" alt />
                <span>Google</span>
              </a>
            </li>
            <li class="divider"></li>
            <li class="facebook">
              <a @click.prevent="signUpBySocial('facebook')">
                <img src="@/assets/icons/facebook.svg" alt />
                <span>Facebook</span>
              </a>
            </li>
            <li class="divider"></li>
            <li class="microsoft">
              <a @click.prevent="signUpBySocial('microsoft')">
                <img src="@/assets/icons/microsoft.svg" width="20" alt />
                <span>Microsoft</span>
              </a>
            </li>
          </ul>

          <p class="dont-have-account">
            Already have an account?
            <a href="/signup" @click.prevent="$router.push({ name: 'login' })">Sign in</a>
          </p>
        </div>
      </div>
    </div>
    <div class="terms-conditions" v-show="showTerms">
      <div class="widget-body">
        <div class="info-panel">
          <button class="back-btn" @click="showTerms = false">
            <img src="../assets/icons/back__ic.svg" />
            <span>Back</span>
          </button>
          <terms-widget />
          <div class="bottom">
            <button class="__transparent" @click="showTerms = false">
              Back
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import VuePassword from "vue-password";
import TermsWidget from "@/components/TermsWidget.vue";
export default {
  name: "signup",
  components: {
    VuePassword,
    TermsWidget,
  },
  computed: {
    ...mapGetters([
      "getLocale",
      "getMessages",
      "getHelper",
      "getAlert",
      "getErrorMsg",
    ]),
    isInvited() {
      return !(
        this.$cookies.get("project-token") === null &&
        this.$cookies.get("employment-token") === null
      );
    },
    isPageReady() {
      // return true;
      return !(this.getMessages === null || this.getMessages === undefined);
    },

    pageContent() {
      return this.getMessages;
    },
    isErrorOnFirstName() {
      return this.getErrorMsg.type === "first_name";
    },
    isErrorOnLastName() {
      return this.getErrorMsg.type === "last_name";
    },
    isErrorOnEmail() {
      return this.getErrorMsg.type === "sign_up_email";
    },
    isErrorOnPassword() {
      return this.getErrorMsg.type === "sign_up_password";
    },
    isErrorOnComfirmPassword() {
      return this.getErrorMsg.type === "comfirm_password";
    },
  },
  watch: {
    "signup_fields.password": function (new_val, old_val) {
      this.pass_strength = this.scorePassword(new_val);
    },
  },
  data() {
    return {
      error_message: "",
      showTerms: false,
      is_registering: false,
      check: false,
      pass_strength: 0,
      signup_fields: {
        account_type: "1",
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        comfirm_password: "",
      },
      loading: false,
      weekPassword: false,
    };
  },
  mounted() {
    let vm = this;
    if (vm.isInvited) {
      vm.is_registering = true;
    }
    if (vm.$route.query.type) {
      if (vm.$route.query.type == "consultant") {
        vm.signup_fields.account_type = "1";
        vm.is_registering = true;
      }
    }
    vm.$store.commit("AUTH_REQUEST_ERROR", {});
  },
  methods: {
    scorePassword(pass) {
      var score = 0;
      if (pass) {
        var variations = {
          digits: /\d/.test(pass),
          lower: /[a-z]/.test(pass),
          upper: /[A-Z]/.test(pass),
          nonWords: /\W/.test(pass),
        };

        var variationCount = 0;
        for (var check in variations) {
          variationCount += variations[check] == true ? 1 : 0;
        }
        score = variationCount;
        return parseInt(score);
      }
      return 0;
    },
    signUpBySocial(sign_type) {
      let vm = this;
      sessionStorage.setItem("is_login", false);
      this.$cookies.set(
        "account-type",
        parseInt(this.signup_fields.account_type)
      );

      vm.loading = true;
      if (sign_type == "linkedin") {
        this.$store
          .dispatch("AUTH_LINKEDIN_SIGNUP_REQUEST", {})
          .then((responce) => {
            vm.loading = false;
          });
      } else if (sign_type == "google") {
        this.$store
          .dispatch("AUTH_GOOGLE_SIGNUP_REQUEST", {})
          .then((responce) => {
            vm.loading = false;
          });
      } else if (sign_type == "facebook") {
        this.$store
          .dispatch("AUTH_FACEBOOK_SIGNUP_REQUEST", {})
          .then((responce) => {
            vm.loading = false;
          });
      } else if (sign_type == "microsoft") {
        this.$store
          .dispatch("AUTH_MICROSOFT_SIGNUP_REQUEST", {})
          .then((responce) => {
            vm.loading = false;
          });
      }
    },
    signUpByConsultified() {
      let vm = this;
      if (vm.check) {
        vm.loading = true;
        this.$cookies.set(
          "account-type",
          parseInt(this.signup_fields.account_type)
        );
        if (vm.pass_strength >= 3) {
          if (vm.signup_fields.password == vm.signup_fields.comfirm_password) {
            vm.$store
              .dispatch("CONSULTIFIED_SIGNUP", vm.signup_fields)
              .then((response) => {
                vm.loading = false;
                vm.$router.push({
                  name: "account_activation",
                  query: { type: "email", reference: vm.signup_fields.email },
                });
              })
              .catch((error) => {
                vm.loading = false;
                let response = error.response;
                if (response.status === 401 || response.status === 400) {
                  vm.error_message = error.response.data.error.message;
                  return;
                }
              });
          } else {
            vm.loading = false;
            vm.error_message = "Password does not match";
          }
        } else {
          vm.weekPassword = true;
          vm.loading = false;
        }
      } else {
        vm.error_message = "Please accept terms and condition";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  position: relative;
  min-height: 100%;
  display: block;
  text-align: center;
  overflow-y: auto;
  background-size: contain;
  z-index: 999999;
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 20px 0px;

  .__container {
    width: 430px;
    margin: 0 auto;

    @media (min-width: 300px) and (max-width: 630px) {
      width: 100%;
    }

    .form {
      display: flex;
      flex-direction: column;

      .logo {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .banner {
        margin: 20px 0px;

        h5 {
          font-weight: 400;
          font-size: 18px;
          text-align: center;
          color: #676879;
        }

        h1 {
          font-weight: 600;
          font-size: 24px;
          text-align: center;
          color: #000000;
        }
      }

      .login_form {
        margin-top: 0px;
        text-align: left;
        display: flex;
        flex-direction: column;

        @media (min-width: 300px) and (max-width: 630px) {
          padding-left: 20px;
          padding-right: 20px;
        }

        .chech-box {
          margin: 15px 0 10px 0;
          display: flex;
          align-items: center;

          input {
            margin-top: 3px;
            margin-right: 10px;
          }

          label {
            font-family: "Nunito", sans-serif;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.36;
            letter-spacing: 0px;
            text-align: center;
            color: #000000;
          }

          .colored {
            cursor: pointer;
            text-decoration: underline;
            margin-left: 10px;
            color: #1890a9;
          }
        }

        .get-started {
          width: 291px;
          height: 45px;
          background: transparent linear-gradient(109deg, #1ba5a4 0%, #2f90b6 100%) 0% 0% no-repeat padding-box;
          border-radius: 10px;
          color: #fff;
          margin-top: 30px;
        }

        .label {
          color: #000;
          font-weight: normal;
          font-size: 14px;
          margin-top: 15px;
          margin-bottom: 4px;
          margin-left: 20px;
        }

        .error_input {
          border: 1px solid crimson !important;
          color: crimson;
        }

        .error-msg {
          color: crimson;
          text-align: left;
        }
      }

      .bottom {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        margin-top: 15px;

        .btn-signup {
          width: 100%;
          height: 45px;

          @media (min-width: 300px) and (max-width: 630px) {
            width: 300px;
          }
        }

        input[type="checkbox"] {
          background-color: #ffffff;
          position: relative;
          top: -1px;
          margin-right: 5px;
        }

        .sign-in-up-option {
          color: #1ba5a4;
          font-weight: 800;
          margin-top: 20px;
          margin-bottom: 5px;
        }

        .loader {
          margin-top: 10px;

          img {
            width: 30px;
          }
        }

        .social-media-list {
          list-style: none;
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          margin-top: 20px;
          padding-left: 0px;

          @media (min-width: 300px) and (max-width: 630px) {
            display: grid;
            grid-template-columns: 48% 48%;
            grid-gap: 10px;
          }

          li {
            &.divider {
              margin-right: 10px;
            }

            a {
              display: flex;
              align-items: center;
              background: #fff;
              padding: 5px 10px;
              border-radius: 10px;
              border: 1px solid #ccc;

              img {
                width: 20px;
              }

              span {
                margin-top: 2px;
                margin-left: 3px;
                color: #000000;
              }

              &:hover {
                background: #ededed;
                color: #fff;
              }
            }
          }
        }

        .dont-have-account {
          color: #8f95a4;

          a {
            color: #0884af;
            text-decoration: none;
          }
        }
      }
    }
  }

  .terms-conditions {
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;

    .widget-body {
      height: 100%;
      background: #efefef 0% 0% no-repeat padding-box;
      display: flex;
      justify-content: center;
      overflow-y: auto;
      padding-top: 50px;
      padding-bottom: 20px;

      .info-panel {
        background: #ffffff 0% 0% no-repeat padding-box;
        border: 1px solid rgb(226, 226, 226);
        border-radius: 5px;
        width: 800px;
        padding-top: 40px;
        padding-bottom: 20px;
        padding-left: 30px;
        padding-right: 30px;
        display: inline-table;
        position: relative;

        .back-btn {
          position: absolute;
          top: 14px;
          outline: none;
          border: none;
          left: 14px;
          text-decoration: none;
          color: #2991b8;

          span {
            margin-left: 7px;
          }

          img {}
        }

        img.grey_logo {
          margin: 20px 0;
          float: left;
          width: 70px;
          height: 65px;
        }

        img.terms_svg {
          width: 100%;
          display: block;
          margin-top: 20px;
        }

        .bottom {
          margin-top: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;

          button {
            outline: none;
          }

          .__accept {
            font-size: 14px;
            width: 280px;
            height: 25px;
            border-radius: 18px;
            color: #fff;
            background-image: linear-gradient(267deg, #1885ad, #00a3a8);

            outline: none;
            cursor: pointer;
          }

          .__transparent {
            margin-top: 10px;
            color: #2991b8;
          }
        }
      }
    }
  }
}
</style>


